(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["docket-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__docketSliderRegistered) return;
    window.__docketSliderRegistered = true;

    function parseBool(value) {
      return value === 'true';
    }

    function initSlider(root) {
      if (!root || root.dataset.docketInit === 'true') return;

      const viewport = root.querySelector('[data-docket-viewport]');
      const track = root.querySelector('[data-docket-track]');
      const slides = Array.from(root.querySelectorAll('[data-docket-slide]'));
      const prevButton = root.querySelector('[data-docket-prev]');
      const nextButton = root.querySelector('[data-docket-next]');
      const dotButtons = Array.from(root.querySelectorAll('[data-docket-dot]'));
      const live = root.querySelector('[data-docket-live]');
      const progressBar = root.querySelector('[data-docket-progress]');
      const autoplay = parseBool(root.dataset.docketAutoplay);
      const loop = parseBool(root.dataset.docketLoop);
      const interval = parseInt(root.dataset.docketInterval, 10) || 6000;

      if (!viewport || !track || slides.length === 0) return;

      root.dataset.docketInit = 'true';

      let active = 0;
      let timer = null;
      let touchStartX = null;

      function previousIndex() {
        return (active - 1 + slides.length) % slides.length;
      }

      function nextIndex() {
        return (active + 1) % slides.length;
      }

      function updateClasses() {
        const total = slides.length;

        slides.forEach(function (slide, index) {
          const isActive = index === active;
          const relative = (index - active + total) % total;
          const backward = (active - index + total) % total;
          const order = relative <= backward ? relative : -backward;

          slide.classList.toggle('is-active', isActive);
          slide.classList.toggle('is-edge', !isActive && slides.length > 1);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.style.order = String(order);
        });

        dotButtons.forEach(function (button, index) {
          button.classList.toggle('is-active', index === active);
        });

        if (live) {
          live.textContent = 'Slide ' + (active + 1) + ' of ' + slides.length;
        }
      }

      function warmImage(slideIndex, priority) {
        const slide = slides[normalize(slideIndex)];
        if (!slide) return;

        const image = slide.querySelector('[data-docket-image]');
        if (!image) return;

        image.loading = 'eager';
        image.decoding = 'async';
        image.fetchPriority = priority === 'high' ? 'high' : 'auto';

        if (image.dataset.docketWarmed === 'true') return;

        const preloadImage = new Image();
        preloadImage.decoding = 'async';
        preloadImage.src = image.currentSrc || image.src;
        if (image.srcset) preloadImage.srcset = image.srcset;
        if (image.sizes) preloadImage.sizes = image.sizes;

        image.dataset.docketWarmed = 'true';
      }

      function warmVisibleImages() {
        warmImage(active, 'high');
        if (slides.length > 1) {
          warmImage(active - 1, 'auto');
          warmImage(active + 1, 'auto');
          warmImage(active - 2, 'auto');
          warmImage(active + 2, 'auto');
        }
      }

      function positionTrack() {
        const activeSlide = slides[active];
        if (!activeSlide) return;

        const sliderWidth = viewport.clientWidth;
        const activeCenter = activeSlide.offsetLeft + (activeSlide.clientWidth / 2);
        const targetCenter = sliderWidth / 2;

        track.style.transform = 'translateX(' + (targetCenter - activeCenter) + 'px)';
      }

      function schedulePositionTrack() {
        requestAnimationFrame(function () {
          requestAnimationFrame(positionTrack);
        });
      }

      function restartProgress() {
        if (!progressBar) return;
        progressBar.style.transition = 'none';
        progressBar.style.width = '0%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            progressBar.style.transition = 'width ' + interval + 'ms linear';
            progressBar.style.width = '100%';
          });
        });
      }

      function stopAutoplay(resetProgress) {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        if (resetProgress && progressBar) {
          progressBar.style.transition = 'none';
          progressBar.style.width = '0%';
        }
      }

      function startAutoplay() {
        if (!autoplay || slides.length < 2) return;
        stopAutoplay(false);
        restartProgress();
        timer = setInterval(function () {
          go(active + 1, false);
        }, interval);
      }

      function normalize(index) {
        if (loop) {
          return (index + slides.length) % slides.length;
        }
        return Math.max(0, Math.min(index, slides.length - 1));
      }

      function go(index, restartTimer) {
        active = normalize(index);
        updateClasses();
        warmVisibleImages();
        schedulePositionTrack();
        if (restartTimer !== false) {
          startAutoplay();
        }
      }

      slides.forEach(function (slide, index) {
        slide.addEventListener('click', function (event) {
          if (event.target.closest('.docket-slider__button') || event.target.closest('.docket-slider__link')) return;
          if (index !== active) {
            go(index, true);
          }
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          go(active - 1, true);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          go(active + 1, true);
        });
      }

      dotButtons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          go(index, true);
        });
      });

      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(active + 1, true);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(active - 1, true);
        }
      });

      viewport.addEventListener('mouseenter', function () {
        stopAutoplay(false);
      });

      viewport.addEventListener('mouseleave', function () {
        startAutoplay();
      });

      viewport.addEventListener('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
      }, { passive: true });

      viewport.addEventListener('touchend', function (event) {
        if (touchStartX === null) return;
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 40) {
          go(deltaX < 0 ? active + 1 : active - 1, true);
        }
        touchStartX = null;
      }, { passive: true });

      window.addEventListener('resize', schedulePositionTrack);

      updateClasses();
      warmVisibleImages();
      schedulePositionTrack();
      startAutoplay();
    }

    function initAll(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-docket-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      }, { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-cinema"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__ciSlideshowRegistered) return;
    window.__ciSlideshowRegistered = true;

    function parseBool(value) {
      return value === 'true';
    }

    function getConfig(root) {
      return {
        autoplay: parseBool(root.dataset.ciAutoplay),
        interval: parseInt(root.dataset.ciInterval, 10) || 6000,
        loop: parseBool(root.dataset.ciLoop),
        heroArMode: root.dataset.ciHeroArMode || 'fixed',
        peek: parseInt(root.dataset.ciPeek, 10) || 180,
        slideGap: parseInt(root.dataset.ciSlideGap, 10) || 6,
        stripHeight: parseInt(root.dataset.ciStripHeight, 10) || 72,
        stripGap: parseInt(root.dataset.ciStripGap, 10) || 6,
        showStrip: parseBool(root.dataset.ciShowStrip),
      };
    }

    function waitForSplide(cb, tries) {
      tries = tries || 0;
      if (window.Splide) return cb();
      if (tries > 50) {
        console.warn('[SlideshowCinema] Splide failed to load after 5s');
        return;
      }
      setTimeout(function () {
        waitForSplide(cb, tries + 1);
      }, 100);
    }

    function updateDots(dotsEl, idx) {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('button[data-ci-dot]').forEach(function (button, i) {
        button.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    function syncHeroAR(root, mainEl, config) {
      if (config.heroArMode !== 'auto') return;
      const active = mainEl.querySelector('.splide__slide.is-active') || mainEl.querySelector('.splide__slide');
      if (!active) return;
      const ar = parseFloat(active.dataset.ar);
      if (ar && ar > 0) root.style.setProperty('--ci-hero-ar', ar.toFixed(4));
    }

    function restartProgress(progressBar, interval) {
      if (!progressBar) return;
      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          progressBar.style.transition = 'width ' + interval + 'ms linear';
          progressBar.style.width = '100%';
        });
      });
    }

    function initSection(root) {
      if (!root || root.dataset.ciMounted === 'true') return;

      const config = getConfig(root);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mainEl = root.querySelector('[data-ci-main]');
      const stripEl = root.querySelector('[data-ci-strip]');
      const dots = root.querySelector('[data-ci-dots]');
      const live = root.querySelector('[data-ci-live]');
      const progressBar = root.querySelector('[data-ci-progress]');
      const playPauseButton = root.querySelector('[data-ci-playpause]');
      const prev = root.querySelector('[data-ci-prev]');
      const next = root.querySelector('[data-ci-next]');

      if (!mainEl) return;

      const slideCount = mainEl.querySelectorAll('.splide__slide').length;
      if (slideCount === 0) return;

      root.dataset.ciMounted = 'true';

      waitForSplide(function () {
        const state = {
          main: null,
          strip: null,
          autoplayTimer: null,
          playing: false,
        };

        state.main = new window.Splide(mainEl, {
          type: config.loop && slideCount > 1 ? 'loop' : 'slide',
          perPage: 1,
          perMove: 1,
          padding: config.peek,
          gap: config.slideGap,
          pagination: false,
          arrows: false,
          drag: slideCount > 1,
          keyboard: 'focused',
          speed: reducedMotion ? 0 : 620,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          autoHeight: false,
          updateOnMove: true,
          flickPower: 240,
        });

        if (stripEl && config.showStrip && slideCount > 1) {
          state.strip = new window.Splide(stripEl, {
            fixedHeight: config.stripHeight + 'px',
            autoWidth: true,
            gap: config.stripGap,
            pagination: false,
            arrows: false,
            isNavigation: true,
            focus: 'center',
            trimSpace: false,
            drag: 'free',
            snap: true,
            keyboard: false,
            speed: reducedMotion ? 0 : 420,
          });
          state.main.sync(state.strip);
        }

        state.main.on('mounted moved', function (newIndex) {
          syncHeroAR(root, mainEl, config);
          if (typeof newIndex === 'number') {
            updateDots(dots, newIndex);
            if (live) live.textContent = 'Slide ' + (newIndex + 1) + ' of ' + slideCount;
            if (state.playing) restartProgress(progressBar, config.interval);
          }
        });

        state.main.mount();
        if (state.strip) state.strip.mount();

        if (prev) prev.addEventListener('click', function () { state.main.go('<'); });
        if (next) next.addEventListener('click', function () { state.main.go('>'); });

        if (dots) {
          dots.querySelectorAll('button[data-ci-dot]').forEach(function (button) {
            button.addEventListener('click', function () {
              const idx = parseInt(button.dataset.ciDot, 10);
              state.main.go(idx);
            });
          });
        }

        if (config.autoplay && slideCount > 1 && playPauseButton) {
          const pauseIcon = playPauseButton.querySelector('.ci-sl__playpause-pause');
          const playIcon = playPauseButton.querySelector('.ci-sl__playpause-play');

          function pauseAutoplay() {
            if (state.autoplayTimer) clearInterval(state.autoplayTimer);
            state.autoplayTimer = null;
            if (progressBar) {
              const width = progressBar.getBoundingClientRect().width;
              const parentWidth = progressBar.parentElement.getBoundingClientRect().width || 1;
              progressBar.style.transition = 'none';
              progressBar.style.width = ((width / parentWidth) * 100) + '%';
            }
          }

          function startAutoplay() {
            state.playing = true;
            restartProgress(progressBar, config.interval);
            state.autoplayTimer = setInterval(function () {
              if (!state.playing) return;
              state.main.go('>');
            }, config.interval);
          }

          function resumeAutoplay() {
            startAutoplay();
          }

          startAutoplay();

          playPauseButton.addEventListener('click', function () {
            if (state.playing) {
              pauseAutoplay();
              state.playing = false;
              playPauseButton.setAttribute('aria-label', 'Play slideshow');
              if (pauseIcon) pauseIcon.hidden = true;
              if (playIcon) playIcon.hidden = false;
            } else {
              resumeAutoplay();
              state.playing = true;
              playPauseButton.setAttribute('aria-label', 'Pause slideshow');
              if (pauseIcon) pauseIcon.hidden = false;
              if (playIcon) playIcon.hidden = true;
            }
          });

          mainEl.addEventListener('mouseenter', function () {
            pauseAutoplay();
          });
          mainEl.addEventListener('mouseleave', function () {
            if (state.playing) resumeAutoplay();
          });
        }
      });
    }

    function initAll(scope) {
      const root = scope && scope.querySelector ? scope : document;
      root.querySelectorAll('[data-ci-slider]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      }, { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
